export const TouchpointType = {
  EMAIL: "EMAIL",
  LANDING_PAGE: "LANDING_PAGE",
  THEME: "THEME",
  OTHER: "OTHER",
} as const;
export type TouchpointType = (typeof TouchpointType)[keyof typeof TouchpointType];
export type CreatableTouchpointType =
  | typeof TouchpointType.EMAIL
  | typeof TouchpointType.LANDING_PAGE
  | typeof TouchpointType.OTHER;

export const TouchpointTypeLabel = {
  EMAIL: "Email",
  EMAILS: "Emails",
  OTHER: "Other",
  LP_TOUCHPOINT: "Web page", // Formerly "Landing Page"
  FOLDER: "Folder",
} as const;
export type TouchpointTypeLabel = (typeof TouchpointTypeLabel)[keyof typeof TouchpointTypeLabel];

export enum TouchpointStatus {
  DESIGN = "Design",
  DEVELOPMENT = "Development",
  DONE = "Done",
  NEW = "New",
  QA = "QA",
}

// TODO: Remove the "" option, but fix functions that require it.
export type LpRedirectionType = "TOUCHPOINT" | "URL" | "NONE" | "";

export interface TouchpointPreviewProps {
  emptyMessage?: string;
  htmlContent: any;
  htmlJSON: string;
  isCommentMode?: boolean;
  mobileView?: boolean;
}

export type TouchpointRedirectDestination = "toBuilder" | "toTouchpoint";
